import counterpart from 'counterpart';

export function registerTranslations() {
  counterpart.registerTranslations('en', require('counterpart/locales/en'));
  // load our own translations
  counterpart.registerTranslations('en', require('./en.json'));
}